import { z } from 'zod';
export const DIFFICULTY_VALUES = ['easy', 'medium', 'hard'];
export const DifficultySchema = z.enum(DIFFICULTY_VALUES);
//# sourceMappingURL=difficulty.js.map